import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrmHttpClientService } from '../PrmHttpClientService';

import { CreateWebClientErrorReportDto, ErrorReportCreatedDto } from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class ServerUtilRepository {
  constructor(
    private httpClientService: PrmHttpClientService,
  ) { }

  getDatabaseTime(): Observable<string> {
    const endpointUrl = `util/database-time`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  reportError(errorReportDto: CreateWebClientErrorReportDto): Observable<ErrorReportCreatedDto> {
    const endpointUrl = `util/report-error`;
    return this.httpClientService.sendPostRequest(endpointUrl, errorReportDto);
  }
}
